
import { apiGetRequest, apiPostRequest } from '@/api/http'

// PageInfo<ApplicationEntity>
// GET /app/list
export const getAppList = (params) => {
    return apiGetRequest('lechun-ai/app/list', params)
}

// ApplicationEntity
// GET /app/detail
export const getAppDetail = (params) => {
    return apiGetRequest('lechun-ai/app/detail', params)
}

// Save or Update
// POST /app/save
export const saveApp = (params) => {
    return apiPostRequest('lechun-ai/app/save', params)
}

// Update Status
// POST /app/updateStatus
export const updateAppStatus = (params) => {
    return apiPostRequest('lechun-ai/app/updateStatus', params)
}

// Get API Key
// GET /app/getApplicationAppKey
export const getApplicationAppKey = (params) => {
    return apiGetRequest('lechun-ai/app/getApplicationAppKey', params)
}

// Delete (Physical delete)
// GET /app/delete
export const deleteApp = (params) => {
    return apiGetRequest('lechun-ai/app/delete', params)
}


